export class InsuredTripChangeEndDateRequest {
    policyNumber: string; // číslo rámcovej zmluvy
    policyNumberTravelMember: string; // číslo poistenej cesty
    dateEnd: string;
    dateBegin: string;
    statusId: number;
}